jQuery(document).ready(function($) {
    if ($('body.page-template-page-recommendations').length == 0) return;
    mostHandler.init();

    if (location.hash) {
        var hash = location.hash.replace('#', '');
        mostHandler.isDirectlyLoaded = true;
        mostHandler.goToMost(hash);
    }
});
